import React from "react";
import Modal from "./Modal";
import { ActionTypeIcon, ActivityLogEyeIcon, Close } from "../icons";

const Field = ({ label, value }) => (
  <div>
    <label className="block text-sm text-[#374151] mb-1 font-medium">
      {label}
    </label>
    <div className="bg-white p-2 rounded text-[#111827] text-sm border border-[#E5E7EB]">
      {value}
    </div>
  </div>
);

export default function ActivityLogDetailsModal({
  open,
  onClose,
  logData = {},
}) {
  const getActionTypeBadge = (actionType) => {
    const isSuccess = actionType === "Login";
    return (
      <div
        className={`inline-flex items-center gap-1 px-[9px] py-0.5 rounded-full font-medium text-xs ${
          isSuccess
            ? "bg-[#DCFCE7] text-[#166534]"
            : "bg-[#FCE3DC] text-[#B30606]"
        }`}
      >
        <ActionTypeIcon color={isSuccess ? "#166534" : "#B30606"} />{" "}
        <span>{actionType}</span>
      </div>
    );
  };

  return (
      <Modal
        open={open}
        onClose={onClose}
        title={null}
        panelClassName="max-w-[672px] pt-0 pb-9 px-0 max-h-[95vh] overflow-y-auto rounded-2xl"
        centered={false}
      >
        <div className="w-full">
        {/* Header */}
        <div className="flex items-start sm:items-center justify-between bg-[#6D4E8A1A] p-4 sm:p-6 gap-4">
          <div className="flex sm:flex-row items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#6D4E8A] flex-shrink-0 flex items-center justify-center">
              <ActivityLogEyeIcon color="#fff" size="20"/>
            </div>
            <div>
              <p className="text-base sm:text-lg font-semibold text-black">
                Activity Log Details
              </p>
              <p className="text-xs sm:text-sm text-[#4B5563]">
                Complete information for this log entry
              </p>
            </div>
          </div>
          <button onClick={onClose} aria-label="close" className="flex-shrink-0 mt-1 sm:mt-0">
            <Close />
          </button>
        </div>

        <div className="border-t border-[#E5E7EB] pt-6 px-4 sm:px-6">
          {/* Basic Information Section */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Left Column - Basic Info */}
            <div className="bg-[#F9FAFB] rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <div>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00156 14.6667C7.13116 14.6667 6.29916 14.4934 5.50556 14.1467C4.7461 13.809 4.06983 13.3312 3.47676 12.7134C2.8837 12.0956 2.42503 11.3912 2.10076 10.6001C1.76796 9.77342 1.60156 8.90675 1.60156 8.00008C1.60156 7.09342 1.76796 6.22675 2.10076 5.40008C2.42503 4.60897 2.8837 3.90453 3.47676 3.28675C4.06983 2.66897 4.7461 2.19119 5.50556 1.85342C6.29916 1.50675 7.13116 1.33342 8.00156 1.33342C8.87196 1.33342 9.70396 1.50675 10.4976 1.85342C11.257 2.19119 11.9333 2.66897 12.5264 3.28675C13.1194 3.90453 13.5781 4.60897 13.9024 5.40008C14.2352 6.22675 14.4016 7.09342 14.4016 8.00008C14.4016 8.90675 14.2352 9.77342 13.9024 10.6001C13.5781 11.3912 13.1194 12.0956 12.5264 12.7134C11.9333 13.3312 11.257 13.809 10.4976 14.1467C9.70396 14.4934 8.87196 14.6667 8.00156 14.6667ZM8.00156 13.3334C8.9317 13.3334 9.79356 13.089 10.5872 12.6001C11.3552 12.129 11.9653 11.4934 12.4176 10.6934C12.8869 9.86675 13.1216 8.96897 13.1216 8.00008C13.1216 7.03119 12.8869 6.13342 12.4176 5.30675C11.9653 4.50675 11.3552 3.87119 10.5872 3.40008C9.79356 2.91119 8.9317 2.66675 8.00156 2.66675C7.07143 2.66675 6.20956 2.91119 5.41596 3.40008C4.64796 3.87119 4.03783 4.50675 3.58556 5.30675C3.11623 6.13342 2.88156 7.03119 2.88156 8.00008C2.88156 8.96897 3.11623 9.86675 3.58556 10.6934C4.03783 11.4934 4.64796 12.129 5.41596 12.6001C6.20956 13.089 7.07143 13.3334 8.00156 13.3334ZM7.36156 4.66675H8.64156V6.00008H7.36156V4.66675ZM7.36156 7.33342H8.64156V11.3334H7.36156V7.33342Z"
                      fill="#2563EB"
                    />
                  </svg>
                </div>
                <h3 className="text-base font-semibold text-black">
                  Basic Information
                </h3>
              </div>

              <div className="space-y-3">
                <Field label="Log ID" value={logData.logId || "1"} />
                <Field
                  label="Timestamp"
                  value={logData.time || "2024-01-15 14:30:25"}
                />
                <Field
                  label="User Name"
                  value={logData.name || "Rimsha Latif"}
                />
                <Field
                  label="Email Address"
                  value={logData.email || "smdesigner024@gmail.com"}
                />
              </div>
            </div>

            {/* Right Column - Action Details */}
            <div className="bg-[#FAF5FF] rounded-lg p-4">
              <div className="flex items-center gap-2 mb-3">
                <div>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.00187 0.666585L14.0819 4.33325V11.6666L8.00187 15.3333L1.92188 11.6666V4.33325L8.00187 0.666585ZM8.00187 2.21325L3.20187 5.10659V10.8933L8.00187 13.7866L12.8019 10.8933V5.10659L8.00187 2.21325ZM8.00187 10.6666C7.54107 10.6666 7.11441 10.5466 6.72187 10.3066C6.32934 10.0666 6.01787 9.74214 5.78747 9.33325C5.55708 8.92436 5.44187 8.47992 5.44187 7.99992C5.44187 7.51992 5.55708 7.07547 5.78747 6.66658C6.01787 6.2577 6.32934 5.93325 6.72187 5.69325C7.11441 5.45325 7.54107 5.33325 8.00187 5.33325C8.46267 5.33325 8.88934 5.45325 9.28187 5.69325C9.67441 5.93325 9.98588 6.2577 10.2163 6.66658C10.4467 7.07547 10.5619 7.51992 10.5619 7.99992C10.5619 8.47992 10.4467 8.92436 10.2163 9.33325C9.98588 9.74214 9.67441 10.0666 9.28187 10.3066C8.88934 10.5466 8.46267 10.6666 8.00187 10.6666ZM8.00187 9.33325C8.23228 9.33325 8.44561 9.27325 8.64187 9.15325C8.83814 9.03325 8.99388 8.87103 9.10907 8.66658C9.22427 8.46214 9.28187 8.23992 9.28187 7.99992C9.28187 7.75992 9.22427 7.5377 9.10907 7.33325C8.99388 7.12881 8.83814 6.96659 8.64187 6.84659C8.44561 6.72659 8.23228 6.66658 8.00187 6.66658C7.77147 6.66658 7.55814 6.72659 7.36188 6.84659C7.16561 6.96659 7.00987 7.12881 6.89467 7.33325C6.77947 7.5377 6.72187 7.75992 6.72187 7.99992C6.72187 8.23992 6.77947 8.46214 6.89467 8.66658C7.00987 8.87103 7.16561 9.03325 7.36188 9.15325C7.55814 9.27325 7.77147 9.33325 8.00187 9.33325Z"
                      fill="#9333EA"
                    />
                  </svg>
                </div>
                <h3 className="text-base font-semibold text-black">
                  Action Details
                </h3>
              </div>

              <div className="space-y-3">
                <div>
                  <label className="block text-sm text-[#374151] mb-1 font-medium">
                    Action Type
                  </label>
                  <div className="bg-white px-2 py-[9.5px] rounded text-[#111827] text-sm border border-[#E5E7EB]">
                    {getActionTypeBadge(logData.actionType || "Login")}
                  </div>
                </div>
                <Field
                  label="IP Address"
                  value={logData.ipAddress || "192.168.1.100"}
                />
                <div>
                  <label className="block text-sm text-[#374151] mb-1 font-medium">
                    Session Status
                  </label>
                  <div className="bg-white px-2 py-[9.5px] rounded text-[#111827] text-sm border border-[#E5E7EB]">
                    <div className="inline-flex items-center gap-1 px-[9px] py-0.5 rounded-full font-medium text-xs  bg-[#DCFCE7] text-[#166534]">
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M4.98249 7.59001L9.39849 2.99001L10.0705 3.70001L4.98249 9.01001L1.92969 5.82001L2.60169 5.12001L4.98249 7.59001Z"
                          fill="#166534"
                        />
                      </svg>

                      <span>Active</span>
                    </div>
                  </div>
                </div>
                <Field
                  label="Location"
                  value={logData.location || "Pakistan"}
                />
              </div>
            </div>
          </div>

          {/* Action Description Section */}
          <div className="bg-[#F0FDF4] rounded-lg p-4 mt-6">
            <div className="flex items-center gap-2 mb-3">
              <div>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M13.7583 5.33342V14.0001C13.7583 14.1867 13.6964 14.3445 13.5727 14.4734C13.4489 14.6023 13.2975 14.6667 13.1183 14.6667H2.87828C2.69908 14.6667 2.54761 14.6023 2.42388 14.4734C2.30015 14.3445 2.23828 14.1867 2.23828 14.0001V2.00008C2.23828 1.81342 2.30015 1.65564 2.42388 1.52675C2.54761 1.39786 2.69908 1.33342 2.87828 1.33342H9.91828L13.7583 5.33342ZM12.4783 6.00008H9.27828V2.66675H3.51828V13.3334H12.4783V6.00008ZM5.43828 4.66675H7.35828V6.00008H5.43828V4.66675ZM5.43828 7.33342H10.5583V8.66675H5.43828V7.33342ZM5.43828 10.0001H10.5583V11.3334H5.43828V10.0001Z"
                    fill="#16A34A"
                  />
                </svg>
              </div>
              <h3 className="text-base font-semibold text-black">
                Action Description
              </h3>
            </div>
            <div className="mt-3 bg-white px-[13px] py-3 rounded text-black text-sm  border border-[#E5E7EB]">
              {logData.desc || "User logged into the system"}
            </div>
          </div>

         
        </div>
      </div>
    </Modal>
  );
}
